// extracted by mini-css-extract-plugin
module.exports = {"container":"Sa","categoryItem":"Ta","active":"Ua"};